import { render } from "./upcoming-appointments.vue?vue&type=template&id=00f6227f"
import script from "./upcoming-appointments.vue?vue&type=script&lang=js"
export * from "./upcoming-appointments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__